import React from 'react';
import { ArrowDownRightIcon, ArrowUpRightIcon, MinusIcon } from 'lucide-react';
interface StatCardProps {
  label: string;
  value: string;
  helper?: string;
  emphasis?: boolean;
  /** Change vs. a comparison period. */
  trend?: {
    label: string;
    direction: 'up' | 'down' | 'flat';
  };
}
export function StatCard({
  label,
  value,
  helper,
  emphasis = false,
  trend
}: StatCardProps) {
  const TrendIcon = trend?.direction === 'up' ? ArrowUpRightIcon : trend?.direction === 'down' ? ArrowDownRightIcon : MinusIcon;
  const trendTone = trend?.direction === 'up' ? 'bg-emerald-50 text-emerald-700' : trend?.direction === 'down' ? 'bg-red-50 text-red-700' : 'bg-slate-100 text-slate-600';
  return <div className={`rounded-xl border p-5 shadow-card ${emphasis ? 'border-brand-200 bg-brand-50' : 'border-slate-200 bg-white'}`} data-id="element-498" data-mp="ntjtbj2j3yt">
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-499" data-mp="1v0jfnyszyn8u">{label}</p>
      <p className={`mt-2 text-2xl font-bold tabular-nums ${emphasis ? 'text-brand-800' : 'text-slate-900'}`} data-id="element-500" data-mp="1uyq548f9jivk">{value}</p>
      {trend ? <p className="mt-2 flex flex-wrap items-center gap-2 text-sm text-slate-500" data-id="element-501" data-mp="sy9gl8kyajnp">
          <span className={`inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-xs font-bold ${trendTone}`} data-id="element-502" data-mp="exyrob37bf56">
            <TrendIcon className="h-3 w-3" aria-hidden="true" data-id="element-503" data-mp="jxb9ghf7tw0w" />
            {trend.label}
          </span>
          {helper}
        </p> : helper ? <p className="mt-1 text-sm text-slate-500" data-id="element-504" data-mp="1ckxp4o1pwr44">{helper}</p> : null}
    </div>;
}